"use client";

import { c as _c } from "react/compiler-runtime";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $createParagraphNode, $getSelection, $insertNodes, $isNodeSelection, $isRangeSelection, COMMAND_PRIORITY_HIGH, KEY_ENTER_COMMAND } from "lexical";
import { useEffect } from "react";
import { $isListItemNode, $isListNode } from "@lexical/list";
import { $isHeadingNode } from "@lexical/rich-text";
import useIsMobileDevice from "@/hooks/isMobileDevice";
import useCapacitor from "@/hooks/useCapacitor";
export default function EnterKeyPlugin(t0) {
  const $ = _c(11);
  const {
    disabled,
    handleSubmit,
    canSubmitWithEnter
  } = t0;
  const isMobile = useIsMobileDevice();
  const {
    isCapacitor
  } = useCapacitor();
  const [editor] = useLexicalComposerContext();
  let t1;
  if ($[0] !== canSubmitWithEnter || $[1] !== disabled || $[2] !== editor || $[3] !== handleSubmit || $[4] !== isCapacitor || $[5] !== isMobile) {
    t1 = () => {
      const insertParagraph = t2 => {
        const {
          forceParagraph: t3
        } = t2 === undefined ? {} : t2;
        const forceParagraph = t3 === undefined ? false : t3;
        editor.update(() => {
          const currentSelection = $getSelection();
          if ($isRangeSelection(currentSelection)) {
            currentSelection.insertParagraph();
            if (forceParagraph) {
              const updatedSelection = $getSelection();
              if ($isRangeSelection(updatedSelection)) {
                const topLevelElement = updatedSelection.anchor.getNode().getTopLevelElementOrThrow();
                if ($isHeadingNode(topLevelElement)) {
                  const paragraphNode = $createParagraphNode();
                  paragraphNode.append(...topLevelElement.getChildren());
                  topLevelElement.replace(paragraphNode);
                  paragraphNode.selectStart();
                }
              }
            }
            return;
          }
          if ($isNodeSelection(currentSelection)) {
            const paragraphNode_0 = $createParagraphNode();
            $insertNodes([paragraphNode_0]);
            paragraphNode_0.selectStart();
          }
        });
      };
      return editor.registerCommand(KEY_ENTER_COMMAND, event => {
        if (disabled || !canSubmitWithEnter()) {
          return false;
        }
        if (isMobile || isCapacitor) {
          return true;
        }
        const selection = $getSelection();
        if ($isRangeSelection(selection)) {
          const anchorNode = selection.anchor.getNode();
          let parentNode = anchorNode.getParent();
          if (parentNode === null) {
            parentNode = anchorNode.getTopLevelElement();
          }
          if ($isListItemNode(parentNode) || $isListNode(parentNode)) {
            return false;
          }
          if ($isHeadingNode(parentNode) && event?.shiftKey) {
            event.preventDefault();
            insertParagraph({
              forceParagraph: true
            });
            return true;
          }
        }
        if (event?.shiftKey) {
          event.preventDefault();
          insertParagraph();
          return true;
        } else {
          event?.preventDefault();
          handleSubmit();
          return true;
        }
      }, COMMAND_PRIORITY_HIGH);
    };
    $[0] = canSubmitWithEnter;
    $[1] = disabled;
    $[2] = editor;
    $[3] = handleSubmit;
    $[4] = isCapacitor;
    $[5] = isMobile;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== editor || $[8] !== isCapacitor || $[9] !== isMobile) {
    t2 = [editor, isMobile, isCapacitor];
    $[7] = editor;
    $[8] = isCapacitor;
    $[9] = isMobile;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  useEffect(t1, t2);
  return null;
}